import React, { useEffect, useState } from 'react'
import classes from './ListInstanceUpdate.module.scss';
import Button from 'shared/components/form-input/button/Button';
import IconMinusAccordion from 'assets/icon/IconMinusAccordion';
import Constants from 'utils/Constants';
import useTrans from 'hooks/use-trans';
import CustomFormProvider from 'shared/components/custom-form/CustomFormProvider';
import { useForm } from 'react-hook-form';
import CustomPagination from '../../custom-pagination/CustomPagination';
import FormSearch from '../../form-search/FormSearch';
import FormItem from '../../form-search/FormItem';
import FormInput from 'shared/components/custom-form/FormInput';
import IconSearch from 'assets/icon/IconSearch';
import EventRegister, { EVENT_SHOW_POPUP, EVENT_SHOW_POPUP_FORM_SEARCH_ATTRIBUTE_HOLON_TEMPLATE } from 'utils/EventRegister';
import FormGroup from '../../form-search/FormGroup';
import { useDispatch } from 'react-redux';
import { actionsHolonInstance } from 'redux/holon-instance/action';
import Loading from 'shared/components/form-input/button/loading/Loading';
import WrapContentBody from '../custom-body/WrapContentBody';
import IconClose from 'assets/icon/IconClose';
import IconCheck from 'assets/icon/IconCheck';
import IconChecked from 'assets/icon/IconChecked';
import ButtonFilter from 'shared/components/form-input/button/ButtonFilter';
import IconPlusAccordion from 'assets/icon/IconPlusAccordion';
import { convertRegexToOptions } from 'utils/Utils';
import CommonText from '../../text/CommonText';
import { CommonRowTableHolonInstance } from 'shared/components/holon-instance/CommonDataFilter';
import FormSelect from 'shared/components/custom-form/FormSelect';
import { useSelector } from 'react-redux';

const HolonTemplateCommon = (props) => {
    const isMulti = props?.isMulti == false ? props?.isMulti : true;
    const { holonTemplateDetailWithHolonTemplate,
        holonInstanceWithHolonTemplate,
        onChangeSaveHolonInstance,
        listDataHolon,
        loading,
        handleChangePageInstance, onSearchListTemplate, holonActive,
        paramSearch,
        handleSearchAttributes,
        handleChangeRowPerPage,
        limit,
        sectionTab,
        onChangeInstance,
        valueSelect = ''
    } = props;

    const methods = useForm();
    const [listTemplate, setListTemplate] = useState([]);
    const { t } = useTrans();
    const [listChoiceTemplateAll, setListChoiceTemplateAll] = useState([]);
    const { holonTemplateMaster } = useSelector(state => state?.holonInstance);
    const [holonTamplate, setHolonTamplate] = useState([])

    useEffect(() => {
        if (!holonTemplateDetailWithHolonTemplate?.id) {
            setListChoiceTemplateAll([]);
            setListTemplate([])
        }
        return () => {
        }
    }, [holonTemplateDetailWithHolonTemplate])

    useEffect(() => {
        if (holonInstanceWithHolonTemplate?.records?.length > 0) {
            if (listDataHolon?.length > 0) {
                let newList = [...holonInstanceWithHolonTemplate?.records];
                let temp = [...newList];
                setListTemplate(temp);
            } else {
                setListTemplate(holonInstanceWithHolonTemplate?.records);
            }
        } else {
            setListTemplate(holonInstanceWithHolonTemplate?.records);
        }
    }, [holonInstanceWithHolonTemplate?.records, listDataHolon]);

    useEffect(() => {
        if (listDataHolon?.length > 0) {
            setListChoiceTemplateAll(listDataHolon);
        } else {
            setListChoiceTemplateAll([])
        }
    }, [listDataHolon])

    const handleAdd = (item) => {
        let newList = [...listTemplate];
        let indexRemove = newList?.findIndex(x => x?.id == item?.id);
        if (indexRemove != -1) {
            let newListChoiceTemplateAll = [...listChoiceTemplateAll]
            newListChoiceTemplateAll.push(item)
            setListChoiceTemplateAll(newListChoiceTemplateAll);
            onChangeSaveHolonInstance({
                id: holonTemplateDetailWithHolonTemplate?.id,
                listHolon: newListChoiceTemplateAll
            });
        }
    }

    const handleSingleAdd = (item) => {
        let newList = [...listTemplate];
        // CHECK INDEX ITEM
        let indexReplace = newList?.findIndex(x => x?.id == item?.id);
        if (indexReplace != -1) {
            let newListChoiceTemplateAll = [item]
            setListChoiceTemplateAll(newListChoiceTemplateAll);
            onChangeSaveHolonInstance({
                id: holonTemplateDetailWithHolonTemplate?.id,
                listHolon: newListChoiceTemplateAll
            });
        }
    }

    const handleRemove = (item) => {
        let newListChoiceTemplateAll = [...listChoiceTemplateAll];
        let indexRemove = newListChoiceTemplateAll?.findIndex(x => x?.id == item?.id);
        if (indexRemove != -1) {

            newListChoiceTemplateAll.splice(indexRemove, 1);
            setListChoiceTemplateAll(newListChoiceTemplateAll);
            onChangeSaveHolonInstance({
                id: holonTemplateDetailWithHolonTemplate?.id,
                listHolon: newListChoiceTemplateAll
            });
        }
    }

    const handleChangePaginationList = (e) => {
        handleChangePageInstance(e);
    }

    const checked = (data, id) => data?.findIndex(x => x?.id == id) != -1 ? true : false;

    const renderDataFilter = (string) => {
        let data = JSON.parse(string);
        data = Object.keys(data)?.map(key => {
            return {
                label: key,
                key: key,
                value: data[key],
            }
        });

        const handleRemoveRouter = (_key) => {
            let index = data?.findIndex(x => x?.key == _key);
            if (index != -1) {
                data?.splice(index, 1);
            }

            let object = {};
            data.forEach((element) => {
                object[`${element?.key}`] = element?.value;
            });

            let params = {
                ...paramSearch
            };
            if (Object.keys(object)?.length > 0) {
                params[Constants.QueryParams.ATTRIBUTES.VALUE] = JSON.stringify(object)
            } else {
                delete params[Constants.QueryParams.ATTRIBUTES.VALUE]
            }

            handleSearchAttributes(params)
        }

        const mapLabel = (key) => {
            return [...holonTemplateDetailWithHolonTemplate?.attributes]?.find(x => x?.key == key)?.label;
        }

        return data?.map((x, key) => {
            return <ButtonFilter key={key} onClick={() => handleRemoveRouter(x?.key)} color='white' size='large' title={`${mapLabel(x?.key)}：${x?.value}`} endIcon={<IconMinusAccordion />} />
        })
    }

    const handleOpenAddSearchCriteria = () => {
        let listFormItem = holonTemplateDetailWithHolonTemplate?.attributes?.filter(x => x?.elementType != Constants.ELEMENT_TYPE.FILE.VALUE && x?.elementType != Constants.ELEMENT_TYPE.IMAGE.VALUE)?.map(x => {
            return {
                elementType: x?.elementType,
                options: convertRegexToOptions(x?.regex),
                label: x?.label,
                key: x?.key,
                id: x?.id,
                [x?.key]: paramSearch?.[Constants.QueryParams.ATTRIBUTES.VALUE] && JSON.parse(paramSearch?.[Constants.QueryParams.ATTRIBUTES.VALUE])[x?.key] ?
                    JSON.parse(paramSearch?.[Constants.QueryParams.ATTRIBUTES.VALUE])[x?.key] : null
            }
        });

        EventRegister.emit(EVENT_SHOW_POPUP, {
            open: true,
            type: EVENT_SHOW_POPUP_FORM_SEARCH_ATTRIBUTE_HOLON_TEMPLATE,
            newWindow: true,
            payload: {
                showHeader: false,
                customStyle: {
                    padding: 0,
                    borderTop: 0
                },
                value: {
                    ...paramSearch
                },
                title: t("Holon_Template.search"),
                listFormItem: listFormItem,
                callback: (_props) => {
                    let dataMain = [];
                    let dataSub = [];

                    _props?.map(x => {
                        if (x[x?.key]) {
                            let index = holonTemplateDetailWithHolonTemplate?.attributes?.findIndex(at => at?.id == x.id);
                            if (index != -1) {
                                dataMain.push(x);
                            } else {
                                dataSub.push(x);
                            }
                        }
                    })

                    let params = {
                        ...paramSearch
                    };
                    if (dataMain?.length > 0) {
                        params[Constants.QueryParams.ATTRIBUTES.VALUE] = JSON.stringify(dataMain?.reduce((obj, cur) => ({ ...obj, [cur?.key]: cur?.[cur?.key] }), {}))
                    }

                    handleSearchAttributes(params);
                },
                formArray: true
            }
        })
    }

    const onSubmit = (data) => {
        onSearchListTemplate(data?.Search, holonActive);
    }

    const onChangeRowPerPage = (e) => {
        handleChangeRowPerPage(e)
    }

    useEffect(() => {
        methods.setValue('holonTemplate', valueSelect)
        if (holonTemplateMaster) {
            let list = [];
            holonTemplateMaster?.forEach(x => {
                list.push({
                    label: x?.name,
                    value: x?.id,
                    key: x?.id,
                })
            });
            setHolonTamplate(list)
        }
        else {
            setHolonTamplate([])
        }
    }, [holonTemplateMaster, valueSelect]);



    return <>
        <div className={classes['wrap-content']}>
            <div className={classes['selected-container']}>
                <div className={classes['list']}>
                    <div className={classes['content-list']}>
                        <CustomFormProvider {...methods}>
                            <form onSubmit={methods.handleSubmit(onSubmit)}>
                                <FormSearch className={classes['custom-form-search']}>
                                    <FormGroup flexWrap="wrap">
                                        <FormItem minWidth={183} maxWidth="183px">
                                            <FormInput
                                                fieldName='Search'
                                                background='white'
                                                className="custom-input"
                                                placeholder={t("search_by_word")}
                                                iconSearch={<IconSearch fontSize={14} />}
                                                onChangeValue={(e) => {
                                                }}
                                                isSearch
                                            />
                                        </FormItem>
                                        {
                                            paramSearch?.[Constants.QueryParams.ATTRIBUTES.VALUE] && renderDataFilter(paramSearch?.[Constants.QueryParams.ATTRIBUTES.VALUE])
                                        }
                                        <FormItem>
                                            <ButtonFilter disabled={holonTemplateDetailWithHolonTemplate?.attributes?.length > 0 ? false : true} onClick={handleOpenAddSearchCriteria} size='large' title={t("Holon_Template.add_search_conditions")} color='white' endIcon={<IconPlusAccordion />} />
                                        </FormItem>
                                    </FormGroup>
                                    <>
                                        <Button color='yellow' type='submit' size='large' title={t('search')} />
                                    </>
                                </FormSearch>
                                <div className={classes['from-item']}>
                                    <p>{t("holon.mine_template")}</p>
                                    <FormSelect
                                        fieldName='holonTemplate'
                                        options={holonTamplate ?? []}
                                        onChangeSelect={(e) => {
                                            onChangeInstance(e)
                                        }}
                                    />
                                </div>
                            </form>
                        </CustomFormProvider>
                        {sectionTab}
                        <div style={{
                            borderRadius: '10px 10px 0px 0px',
                            position: 'relative',
                        }}>
                            {
                                holonTemplateDetailWithHolonTemplate?.attributes?.length > 0 && loading ? <div className={classes['custom-loading']}>
                                    <Loading />
                                </div> : <></>
                            }
                            {
                                holonTemplateDetailWithHolonTemplate?.attributes?.length > 0 ?
                                    <table>
                                        <thead>
                                            <tr>
                                                <th className={classes['content-with-action']}></th>
                                                {
                                                    holonTemplateDetailWithHolonTemplate?.attributes?.filter(x => x?.elementType != Constants.ELEMENT_TYPE.IMAGE.VALUE
                                                        && x?.elementType != Constants.ELEMENT_TYPE.FILE.VALUE &&
                                                        x?.elementType != Constants.ELEMENT_TYPE.PASSWORD.VALUE)?.slice(0, 5)
                                                        ?.map((x, index) => {
                                                            return <th key={index} className={classes['content_with']}>
                                                                <div title={x?.label} className={classes['title-header']}>
                                                                    {x?.label}
                                                                </div>
                                                            </th>
                                                        })
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                !loading && listTemplate?.map((menu, index) => {
                                                    return <tr key={index}>
                                                        <td onClick={(e) => {
                                                            e.stopPropagation();
                                                            if (checked(listChoiceTemplateAll, menu?.id)) {
                                                                handleRemove(menu);
                                                            } else {
                                                                if (isMulti) {
                                                                    handleAdd(menu)
                                                                } else {
                                                                    handleSingleAdd(menu)
                                                                }
                                                            }
                                                        }} className={classes['content-with-action']}>
                                                            {
                                                                checked(listChoiceTemplateAll, menu?.id) ? <IconChecked /> : <IconCheck />
                                                            }
                                                        </td>
                                                        {
                                                            holonTemplateDetailWithHolonTemplate?.attributes?.filter(x => x?.elementType != Constants.ELEMENT_TYPE.IMAGE.VALUE
                                                                && x?.elementType != Constants.ELEMENT_TYPE.FILE.VALUE
                                                                && x?.elementType != Constants.ELEMENT_TYPE.PASSWORD.VALUE)?.slice(0, 5)
                                                                ?.map((template, _index) => {
                                                                    return <td key={_index} className={classes['content_with']} >
                                                                        <div title={template?.elementType == Constants.ELEMENT_TYPE.PASSWORD.VALUE ? Constants.PASSWORD.VALUE : menu?.attributes[template?.key]?.value} className={classes['custom-content-table']}>
                                                                            <CommonText>
                                                                                {CommonRowTableHolonInstance({
                                                                                    attributeHeader: template,
                                                                                    attributes: menu?.attributes
                                                                                })}
                                                                            </CommonText>
                                                                        </div>
                                                                    </td>
                                                                })}
                                                    </tr>
                                                })
                                            }
                                        </tbody>
                                    </table>
                                    : <></>
                            }
                        </div>
                    </div>
                    <div className={classes['custom-pagination-popup']}>
                        <CustomPagination onChangeRowPerpage={onChangeRowPerPage} isRowPerpage={true} page={holonInstanceWithHolonTemplate?.page ?? 1} limit={limit} total={holonInstanceWithHolonTemplate?.total ?? 0} onChange={handleChangePaginationList} />
                    </div>
                </div>
            </div>
        </div>
    </>
}

function ListInstanceUpdate(props) {
    const { payload, showVisible } = props;
    const methods = useForm();
    const [listChoiceTemplateAll, setListChoiceTemplateAll] = useState([]);
    const [listHolonTemplate, setListHolonTemplate] = useState([]);
    const [holonTemplateDetailWithHolonTemplate, setHolonTemplateDetailWithHolonTemplate] = useState({});
    const [holonInstanceWithHolonTemplate, setHolonInstanceWithHolonTemplate] = useState({});
    const [loadingGetInstanceByHolonTemplate, setLoadingGetInstanceByHolonTemplate] = useState(false);
    const [isChangeInstance, setIsChangeInstance] = useState();
    const [holonActive, setHolonActive] = useState(null);
    const [paramSearch, setParamSearch] = useState(null);
    const [keyword, setKeyword] = useState(null);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(Constants.PAGINATION.LIMIT);
    const { t } = useTrans();
    const dispatch = useDispatch();

    const handleOke = () => {
        let data = [];
        listChoiceTemplateAll?.map(x => {
            x?.listHolon?.map(_l => {
                data.push(
                    _l?.id
                )
            })
        })
        payload?.callback(data);
        showVisible()
    }

    const handleGetHolonInstance = ({ paramRqs }) => {

        dispatch({
            type: actionsHolonInstance.GET_HOLON_INSTANCE_WITH_HOLON_TEMPLATE,
            payload: {
                ...paramRqs
            },
            callback: (data) => {
                setHolonInstanceWithHolonTemplate(data);
                setLoadingGetInstanceByHolonTemplate(false);
            }
        })
    }

    const onChangeInstance = (data) => {
        setIsChangeInstance(data)
    }

    useEffect(() => {
        if(!isChangeInstance){
            dispatch({
                type: actionsHolonInstance.GET_HOLON_INSTANCE_DETAIL,
                payload: payload?.ListHolonTemplate[0],
                callback: (data) => {
                    setIsChangeInstance(data?.templateId)
                }
            })
        }else{
            setHolonActive(isChangeInstance);
            setLoadingGetInstanceByHolonTemplate(true);
            let paramRqs = {};
            if (payload[Constants.QueryParams.CONNECTION_KEY_FOR_MULTI.VALUE]) {
                paramRqs[Constants.QueryParams.CONNECTION_KEY_FOR_MULTI.VALUE] = payload?.[Constants.QueryParams.CONNECTION_KEY_FOR_MULTI.VALUE];
            }
            if (payload[Constants.QueryParams.HOLON_ID_FOR_MULTIPLE.VALUE]) {
                paramRqs[Constants.QueryParams.HOLON_ID_FOR_MULTIPLE.VALUE] = payload?.[Constants.QueryParams.HOLON_ID_FOR_MULTIPLE.VALUE];
            }
            if (payload[Constants.QueryParams.IS_SELECT_FOR_CONNECTION.VALUE]) {
                paramRqs[Constants.QueryParams.IS_SELECT_FOR_CONNECTION.VALUE] = payload?.[Constants.QueryParams.IS_SELECT_FOR_CONNECTION.VALUE];
            }
            if (isChangeInstance) {
                paramRqs[Constants.QueryParams.HOLON_TEMPLATE_ID.VALUE] = isChangeInstance;
            }
            handleGetHolonInstance({ paramRqs })
            dispatch({
                type: actionsHolonInstance.HOLON_TEMPLATE_DETAIL_POPUP,
                payload: isChangeInstance,
                callback: (data) => {
                    setHolonTemplateDetailWithHolonTemplate(data)
                }
            })
        }
    }, [
        payload?.ListHolonTemplate,
        isChangeInstance,
        payload[Constants.QueryParams.CONNECTION_KEY_FOR_MULTI.VALUE],
        payload[Constants.QueryParams.IS_SELECT_FOR_CONNECTION.VALUE],
        payload[Constants.QueryParams.HOLON_ID_FOR_MULTIPLE.VALUE]
    ])

    const handleChangeTab = (x) => {
        setParamSearch(null)
        setKeyword(null);
        setHolonActive(x);
        setLoadingGetInstanceByHolonTemplate(true)
        dispatch({
            type: actionsHolonInstance.GET_HOLON_INSTANCE_WITH_HOLON_TEMPLATE,
            payload: {
                [Constants.QueryParams.HOLON_TEMPLATE_ID.VALUE]: x,
                [Constants.QueryParams.CONNECTION_KEY_FOR_MULTI.VALUE]: payload?.[Constants.QueryParams.CONNECTION_KEY_FOR_MULTI.VALUE],
                [Constants.QueryParams.HOLON_ID_FOR_MULTIPLE.VALUE]: payload?.[Constants.QueryParams.HOLON_ID_FOR_MULTIPLE.VALUE],
                [Constants.QueryParams.IS_SELECT_FOR_CONNECTION.VALUE]: payload?.[Constants.QueryParams.IS_SELECT_FOR_CONNECTION.VALUE],
            },
            callback: (data) => {
                setHolonInstanceWithHolonTemplate(data);
                setLoadingGetInstanceByHolonTemplate(false)
            }
        })
        dispatch({
            type: actionsHolonInstance.HOLON_TEMPLATE_DETAIL_POPUP,
            payload: x,
            callback: (data) => {
                setHolonTemplateDetailWithHolonTemplate(data)
            }
        })
    }
    const handleSaveHolonInstance = (dataHolon) => {
        let data = [...listChoiceTemplateAll];
        let index = data?.findIndex(x => x?.id == dataHolon?.id);
        if (index != -1) {
            data[index].listHolon = dataHolon?.listHolon;
        } else {
            data.push(dataHolon);
        }

        setListChoiceTemplateAll(data);
    }

    useEffect(() => {
        if (payload?.value?.length > 0) {
            dispatch({
                type: actionsHolonInstance.GET_LIST_TEMPLATE_ID_WITH_INSTANCE,
                payload: payload?.value?.join(","),
                callback: (_data) => {
                    let dataGroup = _data?.reduce((rv, x) => {
                        const groupIndex = rv?.findIndex((a) => a.id == x?.templateId);
                        if (groupIndex != -1) {
                            rv[groupIndex].listHolon?.push({
                                id: x?.id,
                                name: x?.name,
                                attributes: x?.attributes?.reduce((obj, cur) => ({ ...obj, [cur?.name]: cur }), {})
                            });
                        } else {
                            let data = {
                                id: x?.templateId,
                                listHolon: []
                            };

                            data.listHolon.push({
                                id: x?.id,
                                name: x?.name,
                                attributes: x?.attributes?.reduce((obj, cur) => ({ ...obj, [cur?.name]: cur }), {})
                            });

                            rv?.push(data);
                        }
                        return rv;
                    }, []);
                    setListChoiceTemplateAll(dataGroup);
                }
            })
        }
    }, [payload?.value])

    useEffect(() => {
        if (payload?.ListHolonTemplate) {
            dispatch({
                type: actionsHolonInstance.GET_HOLON_TEMPLATE_WITH_IDS,
                payload: payload?.ListHolonTemplate?.join(","),
                callback: (_data) => {
                    setListHolonTemplate(_data);
                }
            })
        }
    }, [payload?.ListHolonTemplate])

    const handleChangePageInstance = (e) => {
        let params = {};
        setPage(e);
        if (keyword) {
            params[Constants.QueryParams.KEYWORD.VALUE] = keyword;
        }
        if (limit) {
            params[Constants.QueryParams.LIMIT.VALUE] = limit;
        }

        setLoadingGetInstanceByHolonTemplate(true);
        dispatch({
            type: actionsHolonInstance.GET_HOLON_INSTANCE_WITH_HOLON_TEMPLATE,
            payload: {
                [Constants.QueryParams.HOLON_TEMPLATE_ID.VALUE]: holonActive,
                [Constants.QueryParams.OFFSET.VALUE]: e,
                [Constants.QueryParams.CONNECTION_KEY_FOR_MULTI.VALUE]: payload?.[Constants.QueryParams.CONNECTION_KEY_FOR_MULTI.VALUE],
                [Constants.QueryParams.HOLON_ID_FOR_MULTIPLE.VALUE]: payload?.[Constants.QueryParams.HOLON_ID_FOR_MULTIPLE.VALUE],
                [Constants.QueryParams.IS_SELECT_FOR_CONNECTION.VALUE]: payload?.[Constants.QueryParams.IS_SELECT_FOR_CONNECTION.VALUE],
                ...params
            },
            callback: (data) => {
                setHolonInstanceWithHolonTemplate(data);
                setLoadingGetInstanceByHolonTemplate(false);
            }
        })
    }
    const onSearchListTemplate = (e, holonActive) => {

        let params = {};

        if (limit) {
            params[Constants.QueryParams.LIMIT.VALUE] = limit;
        }

        setKeyword(e);
        setLoadingGetInstanceByHolonTemplate(true);
        dispatch({
            type: actionsHolonInstance.GET_HOLON_INSTANCE_WITH_HOLON_TEMPLATE,
            payload: {
                [Constants.QueryParams.HOLON_TEMPLATE_ID.VALUE]: holonActive,
                [Constants.QueryParams.OFFSET.VALUE]: 1,
                [Constants.QueryParams.KEYWORD.VALUE]: e,
                [Constants.QueryParams.ATTRIBUTES.VALUE]: paramSearch?.[Constants.QueryParams.ATTRIBUTES.VALUE],
                [Constants.QueryParams.CONNECTION_KEY_FOR_MULTI.VALUE]: payload?.[Constants.QueryParams.CONNECTION_KEY_FOR_MULTI.VALUE],
                [Constants.QueryParams.HOLON_ID_FOR_MULTIPLE.VALUE]: payload?.[Constants.QueryParams.HOLON_ID_FOR_MULTIPLE.VALUE],
                [Constants.QueryParams.IS_SELECT_FOR_CONNECTION.VALUE]: payload?.[Constants.QueryParams.IS_SELECT_FOR_CONNECTION.VALUE],
                ...params
            },
            callback: (data) => {
                setLoadingGetInstanceByHolonTemplate(false);
                setHolonInstanceWithHolonTemplate(data)
            }
        })
    }

    const handleSearchAttributes = (data) => {
        setParamSearch(data);
        setLoadingGetInstanceByHolonTemplate(true);

        let params = {};
        if (limit) {
            params[Constants.QueryParams.LIMIT.VALUE] = limit;
        }
        dispatch({
            type: actionsHolonInstance.GET_HOLON_INSTANCE_WITH_HOLON_TEMPLATE,
            payload: {
                [Constants.QueryParams.HOLON_TEMPLATE_ID.VALUE]: holonActive,
                [Constants.QueryParams.OFFSET.VALUE]: 1,
                [Constants.QueryParams.KEYWORD.VALUE]: keyword,
                [Constants.QueryParams.ATTRIBUTES.VALUE]: data?.[Constants.QueryParams.ATTRIBUTES.VALUE],
                [Constants.QueryParams.CONNECTION_KEY_FOR_MULTI.VALUE]: payload?.[Constants.QueryParams.CONNECTION_KEY_FOR_MULTI.VALUE],
                [Constants.QueryParams.HOLON_ID_FOR_MULTIPLE.VALUE]: payload?.[Constants.QueryParams.HOLON_ID_FOR_MULTIPLE.VALUE],
                [Constants.QueryParams.IS_SELECT_FOR_CONNECTION.VALUE]: payload?.[Constants.QueryParams.IS_SELECT_FOR_CONNECTION.VALUE],
                ...params
            },
            callback: (data) => {
                setLoadingGetInstanceByHolonTemplate(false);
                setHolonInstanceWithHolonTemplate(data)
            }
        })
    }

    const handleChangeRowPerPage = (e) => {
        let params = {};
        setLimit(e);
        setPage(1);
        if (keyword) {
            params[Constants.QueryParams.KEYWORD.VALUE] = keyword;
        }
        if (e) {
            params[Constants.QueryParams.LIMIT.VALUE] = e;
        }
        setLoadingGetInstanceByHolonTemplate(true);
        dispatch({
            type: actionsHolonInstance.GET_HOLON_INSTANCE_WITH_HOLON_TEMPLATE,
            payload: {
                [Constants.QueryParams.HOLON_TEMPLATE_ID.VALUE]: holonActive,
                [Constants.QueryParams.OFFSET.VALUE]: 1,
                [Constants.QueryParams.CONNECTION_KEY_FOR_MULTI.VALUE]: payload?.[Constants.QueryParams.CONNECTION_KEY_FOR_MULTI.VALUE],
                [Constants.QueryParams.HOLON_ID_FOR_MULTIPLE.VALUE]: payload?.[Constants.QueryParams.HOLON_ID_FOR_MULTIPLE.VALUE],
                [Constants.QueryParams.IS_SELECT_FOR_CONNECTION.VALUE]: payload?.[Constants.QueryParams.IS_SELECT_FOR_CONNECTION.VALUE],
                ...params
            },
            callback: (data) => {
                setHolonInstanceWithHolonTemplate(data);
                setLoadingGetInstanceByHolonTemplate(false);
            }
        })
    }

    return (
        <div className={classes['container']}>
            <CustomFormProvider {...methods}>
                <WrapContentBody
                    showVisible={showVisible} title={payload?.title} isUseBtnBack={false} isUseBackground={false}
                    actionSectionBottom={<Button onClick={handleOke} title={t("save")} />}
                    useForm={false}
                    actionSectionTop={<div onClick={() => showVisible()} className={classes['icon']}>
                        <IconClose color="#929292" fontSize={20} />
                    </div>}
                >
                    <div className={classes['selected-holon-template']}>
                        <HolonTemplateCommon
                            holonTemplateDetailWithHolonTemplate={holonTemplateDetailWithHolonTemplate}
                            holonInstanceWithHolonTemplate={holonInstanceWithHolonTemplate}
                            value={payload?.value}
                            isMulti={payload?.isMulti}
                            onChangeSaveHolonInstance={handleSaveHolonInstance}
                            listDataHolon={listChoiceTemplateAll?.find(x => x?.id == holonActive)?.listHolon}
                            loading={loadingGetInstanceByHolonTemplate}
                            handleChangePageInstance={handleChangePageInstance}
                            onSearchListTemplate={onSearchListTemplate}
                            holonActive={holonActive}
                            paramSearch={paramSearch}
                            handleSearchAttributes={handleSearchAttributes}
                            handleChangeRowPerPage={handleChangeRowPerPage}
                            limit={limit}
                            onChangeInstance={onChangeInstance}
                            valueSelect={isChangeInstance}
                            sectionTab={<div className={classes['custom-tab-holon-template']}>
                                {listHolonTemplate?.map((x, key) => {
                                    return <div key={key} style={{
                                        pointerEvents: loadingGetInstanceByHolonTemplate ? 'none' : 'fill'
                                    }} onClick={() => {
                                        !loadingGetInstanceByHolonTemplate && handleChangeTab(x?.id)
                                    }} className={`${classes['custom-tab']} ${holonActive == x?.id ? classes['custom-tab-active'] : ''}`}>
                                        <span>{x?.name}</span>
                                        {
                                            listChoiceTemplateAll?.find(v => v?.id == x?.id)?.listHolon?.length > 0 ? <div className={classes['custom-tab-number']}>
                                                <p>{listChoiceTemplateAll?.find(v => v?.id == x?.id)?.listHolon?.length}</p>
                                            </div> : <></>
                                        }
                                    </div>
                                })}
                            </div>}
                        />
                    </div>
                </WrapContentBody>
            </CustomFormProvider>
        </div>
    )
}

export default ListInstanceUpdate;